export default "__VITE_ASSET__$y76_hKB__"